const BASE_URL = process.env.REACT_APP_BASE_URL || "";
const FILE_FETCH_URL = process.env.REACT_APP_UPLOAD_ENDPOINT || "";

const USER_URL = BASE_URL + "user/";
const COORDINATOR_URL = BASE_URL + "coordinator/";
const PACKAGES_BASE_URL = BASE_URL + "package/";
const ORDER_BASE_URL = BASE_URL + "order/";
const MOCKTEST_BASE_URL = BASE_URL + "mockTest/";
const BHARATSATEXAM_BASE_URL = BASE_URL + "bharatSatExam/";
const STUDYMATERIALS_BASE_URL = BASE_URL + "studyMaterials/";

const ApiConstants = {
  BASE_URL: BASE_URL,
  FILE_FETCH_URL: BASE_URL.concat(FILE_FETCH_URL),

  // - Auth Service Endpoints
  login: USER_URL + "login",
  logout: USER_URL + "logout",
  verifyOtp: USER_URL + "verifyOtp",
  coordinatorverifyOtp: COORDINATOR_URL + "verifyOtp",
  forgotPassword: USER_URL + "forgetPassword",
  resetPassword: USER_URL + "resetPassword",
  getAdminDetails: USER_URL + "details",
  getCoordinatorDetails: COORDINATOR_URL + "details",
  changePassword: USER_URL + "changePassword",
  updateProfileDetails: USER_URL + "updateProfileDetails",

  // - Terms & Conditions
  getTermsAndConditions: BASE_URL + "termsConditions/get-terms-condition",

  // - Privacy Policy
  getPrivacyPolicy: BASE_URL + "privacyPolicy/get-privacy-policy",

  // - Cancellation Policy
  getCancellationPolicy:
    BASE_URL + "cancellationPolicy/get-cancellation-Condition",

  // - Contact Us
  submitContactUsApi: BASE_URL + "contactUs/addContactApi",

  // - Get Social Media Links & Contact Info
  getSocialContactInfo: BASE_URL + "user/getSocialContactInfo",

  // - Get About Us Page Content for Cards
  getAboutUsPageContent: BASE_URL + "user/getAboutUsPageContent",

  // - Get Home Data Sliders + Testimonials
  getHomeData: BASE_URL + "sliders/getHomeData",

  // - Get All Classes added by Admin
  getAllClasses: BASE_URL + "class/getAllClasses",

  getAllStates: BASE_URL + "state/all",
  getAllDistricts: BASE_URL + "district/all",
  getAllTalukas: BASE_URL + "taluka/all",
  getAllPincodes: BASE_URL + "pincode/all",

  // - Get FAQ added added by Admin
  getFaqdata: BASE_URL + "faq/getAll?faq_Category_id=",

  // - Get FAQ added added by Admin
  getFaqcategory: BASE_URL + "faqCategory/list-all-faq-category",

  // - Register Student
  registerStudent: BASE_URL + "user/register",

  // - Verify OTP for registration of student
  verifyOtpRegistrationStudent: BASE_URL + "user/verify-otp-registration",

  // - JoinasCoordinator form
  submitCoordinatorApi: BASE_URL + "coordinator/add-coordinator",
  verifyCoordinatorUniqueCode: BASE_URL + "coordinator/verify-unique-code",

  // - Blog
  getBlogcategory: BASE_URL + "blogCategory/list-all-blog-category",
  getBlogdata: BASE_URL + "blog/getAll?blog_Category_id=",
  getBlogDetailById: BASE_URL + "blog/getBlogDetailsById?blog_id=",
  // - Author
  getAllAuthers: BASE_URL + "author/list-authors",


  //-Packages
  getAllPackages: PACKAGES_BASE_URL + "getAll",
  getAllPackagesByID: PACKAGES_BASE_URL + "getDetailById?package_id=",
  addToCart: PACKAGES_BASE_URL + "addToCart",
  getAllCart: PACKAGES_BASE_URL + "getAllCart",
  deleteCart: PACKAGES_BASE_URL + "deleteCart",
  packagePurchase: PACKAGES_BASE_URL + "verifyPayment",
  createOrder: PACKAGES_BASE_URL + "createOrder",
  checkReferralCode: PACKAGES_BASE_URL + "checkReferralCode",
  // packagePurchase: PACKAGES_BASE_URL + "razorpay-webhook",


  //StudyMaterilas
  getAllStudyMaterials: STUDYMATERIALS_BASE_URL + "getAll",
  getAllModuleByID: STUDYMATERIALS_BASE_URL + "getAllModuleBySubject",
  getAllTopics: STUDYMATERIALS_BASE_URL + "getAllTopics",

  //UpdateProfle

  getprofilepic: USER_URL + "updateProfile",
  deleteprofilePicture: USER_URL + "deleteprofilePicture",

  //OrderHistory
  getOrderHistory: ORDER_BASE_URL + "getAll",
  invoice: ORDER_BASE_URL + "invoice",

  //MockTest
  getAllMockTest: MOCKTEST_BASE_URL + "getAll",
  submitMockTest: MOCKTEST_BASE_URL + "submitMockTest",
  getAllQuestionsById: MOCKTEST_BASE_URL + "getAllQuestionById",
  getShowResults:MOCKTEST_BASE_URL +"getShowResults",
  getAllResultByID: MOCKTEST_BASE_URL + "viewResult",

  coordinatorlogin: COORDINATOR_URL + "login",
  coforgotPassword: COORDINATOR_URL + "forgetPassword",
  coresetPassword: COORDINATOR_URL + "resetPassword",
  cochangePassword: COORDINATOR_URL + "changePassword",
  coupdateProfileDetails: COORDINATOR_URL + "updateProfile",
  addBankDetails: COORDINATOR_URL + "addBankDetails",


  //purchase list
  getAllPurchaseList: COORDINATOR_URL + "getAllPurchaseList",
  getwithdrawReq: BASE_URL + "withdrawReq",
  getwithdrawlamount: BASE_URL + "withdrawReq",
  gettransactionhistory: COORDINATOR_URL + "getTransactionHistory",

  //Bhara-Sat Exam
  getAllBharaSatExamQuestionsById: BHARATSATEXAM_BASE_URL + "getAllQuestion",
  submitbharatSatExam: BHARATSATEXAM_BASE_URL + "submitbharatSatExam",
  // fetchBharatSatCart: BHARATSATEXAM_BASE_URL + "fetchBharatSatCart",

};

export default ApiConstants;
